import { render, staticRenderFns } from "./WorkflowDefinitionList.vue?vue&type=template&id=5d2dba84&"
import script from "./WorkflowDefinitionList.vue?vue&type=script&lang=js&"
export * from "./WorkflowDefinitionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports